module.exports = __webpack_public_path__ + "img/groundDefuserTroop.c6e1995e.png";